import { render } from "./PublicPage.vue?vue&type=template&id=0dc76cbc"
import script from "./PublicPage.vue?vue&type=script&lang=js"
export * from "./PublicPage.vue?vue&type=script&lang=js"

import "./PublicPage.vue?vue&type=style&index=0&id=0dc76cbc&lang=css"

import exportComponent from "C:\\Users\\pawarawat\\Documents\\Vue\\WebServer_Vue_NameCardSouvenir\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__